module.exports = __webpack_public_path__ + "static/img/ss.c6562dd4.png";